import React from "react";
import { Navigate } from "react-router-dom";

// This component checks if the user is authenticated
const PrivateRoute = ({ children }) => {
  const user = localStorage.getItem("linko_web");

  if (!user) {
    // Redirect to login if the user is not authenticated
    return <Navigate to="/login" />;
  }

  return children;
};

export default PrivateRoute;
